import {find} from 'ramda'
import {startDate, endDate, riskType, recentEventsOptions} from '@/defaults'
import {sequenceFuturesObject} from '@/store/future-helpers'

export const findDefaultPortfolio =
  find((p) => p.isDefault && !p.sharedByUserName)

export const getPortfolioCompaniesQuery = (state) => {
  const {
    portfolioPaging,
    portfolioCountryFilter,
    portfolioSearchFilter,
    portfolioCompaniesSortOptions,
  } = state.ui

  const params = {
    page: portfolioPaging.pageNumber,
    pageSize: portfolioPaging.pageSize,
    sortBy: portfolioCompaniesSortOptions.sortBy,
    sortDir: portfolioCompaniesSortOptions.sortDir,
  }
  if (portfolioCountryFilter !== 'all') {
    params.countryCode = portfolioCountryFilter
  }
  if (portfolioSearchFilter !== '') {
    params.searchQuery = portfolioSearchFilter
  }
  return params
}

export const getPortfolioCompaniesByRiskTypeQuery = (state) => {
  const {
    shownRiskRating,
    companiesByRiskTypePaging,
    companiesByRiskTypeSortOptions,
  } = state.ui

  const params = {
    page: companiesByRiskTypePaging.pageNumber,
    pageSize: companiesByRiskTypePaging.pageSize,
    riskType: shownRiskRating,
    sortBy: companiesByRiskTypeSortOptions.sortBy,
    sortDir: companiesByRiskTypeSortOptions.sortDir,
  }

  return params
}

export const getScheduledExportsQuery = (state) => {
  const {
    scheduledExportsPaging,
    scheduledExportsSortOptions,
  } = state.ui

  const params = {
    page: scheduledExportsPaging.pageNumber,
    pageSize: scheduledExportsPaging.pageSize,
    sortBy: scheduledExportsSortOptions.sortBy,
    sortDir: scheduledExportsSortOptions.sortDir,
  }

  return params
}

export const getPreviousExportsQuery = (state) => {
  const {
    previousExportsPaging,
    previousExportsSortOptions,
  } = state.ui

  const params = {
    page: previousExportsPaging.pageNumber,
    pageSize: previousExportsPaging.pageSize,
    sortBy: previousExportsSortOptions.sortBy,
    sortDir: previousExportsSortOptions.sortDir,
  }

  return params
}

export const fetchHomeTabData = (api) => (id: number = 0, languageCode: string = 'en') =>
  sequenceFuturesObject({
    notificationEvents: api.fetchPortfolioEvents(id, {
      startDate,
      endDate,
      sortDir: recentEventsOptions.sortDir,
      sortBy: recentEventsOptions.sortBy,
      language: languageCode,
    }),
  })

export const fetchPortfoliosTabData = (api) => (id: number = 0, lang: string = 'GB') =>
  sequenceFuturesObject({
    companies: api.fetchPortfolioCompanies(id, {}, 'portfolios', lang),
    countries: api.fetchPortfolioCountries(id),
  })

export const fetchAnalysisTabData = (api) => (id: number = 0, lang: string = 'GB') =>
  sequenceFuturesObject({
    riskSummary: api.fetchPortfolioRiskSummary(id),
    companiesByRiskType: api.fetchPortfolioCompanies(id, {riskType: riskType}, 'analysis', lang),
  })



// WEBPACK FOOTER //
// ./src/store/common.js